import env from 'src/utils/env';

export const { TWILIO_URL } = env;

const TWILIO_TOKEN = '/token';
const TWILIO_SEND_NOTIFICATION = '/send-notification';
const TWILIO_READ_HORIZON = '/update-read-horizon';

export async function fetchTwilioToken(identity: string) {
  const tokenUrl = buildTwilioUrl(TWILIO_TOKEN, { identity });
  const res = await fetch(tokenUrl);
  const { accessToken } = (await res.json()) || {};

  return accessToken;
}

export async function sendNotification({
  identity = '',
  type = 0,
  title = 'Allurion Insights',
  body = '',
  roomId = '',
  sound = '',
  filename = '',
}) {
  const sendNotificationUrl = buildTwilioUrl(TWILIO_SEND_NOTIFICATION, {
    identity,
    type,
    title,
    // Only include optional params when they have a value.
    ...(roomId ? { roomID: roomId } : {}),
    ...(sound ? { sound } : {}),
    ...(body ? { body } : {}),
    ...(filename ? { filename } : {}),
  });

  const res = await fetch(sendNotificationUrl);
  const r = await res.json();

  // eslint-disable-next-line no-console
  console.debug('sendNotification: ', r);
}

export async function updateReadHorizon(conversationSid: string, uniqueName: string) {
  const updateReadHorizonUrl = buildTwilioUrl(TWILIO_READ_HORIZON, {
    conversationSID: conversationSid,
    uniqueName,
  });

  const res = await fetch(updateReadHorizonUrl, {
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  });
  const data = await res.json();

  return data;
}

// Build a Twilio URL with all query values URL-encoded. URLSearchParams handles
// escaping of &, =, #, +, ?, spaces, etc. so raw identities/SIDs/bodies cannot
// break the URL or inject extra query params.
function buildTwilioUrl(
  pathname: string,
  query: { [attribute: string]: string | number | null | undefined }
) {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    params.append(key, String(value));
  });

  // URLSearchParams.toString() form-encodes spaces as `+`, but the Twilio/AWS
  // endpoint may not decode `+` back to a space, so normalize to `%20` to keep
  // the previous encoding semantics. Every `+` here is an encoded space (a
  // literal `+` in a value is encoded as `%2B`), so this replace is safe.
  const queryStr = params.toString().replace(/\+/g, '%20');

  return queryStr ? `${TWILIO_URL}${pathname}?${queryStr}` : `${TWILIO_URL}${pathname}`;
}
